/* global pendo */
import { useEffect, useState, createContext } from "react";
import { Toaster } from "react-hot-toast";
import { Outlet, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { selectIsMobile, selectUser, setIsMobile } from "../redux/features/appData";
import * as screens from "../utils/screens";
import { Sidebar } from "../components/sidebar/Sidebar";
import { Header } from "../components/header/Header";

// this is the OAuth route so we have no password
export const ThemeContext = createContext();

export default function Root() {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const storeUser = useSelector(selectUser);
  const isMobile = useSelector(selectIsMobile);

  const initialState = {};
  const [rootData, setRootData] = useState(initialState);

  const handleWindowResize = () => {
    dispatch(setIsMobile(screens.isMobile()));
  };

  useEffect(() => {
    if (isMobile) {
      navigate("/logout");
    }
  }, [isMobile]);

  useEffect(() => {
    dispatch(setIsMobile(screens.isMobile()));
    window.addEventListener("resize", handleWindowResize);

    // if not logged in bounce there
    if (!storeUser) {
      navigate("/login");
      return;
    }

    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  if (storeUser) {
    document.body.className = storeUser.theme;
  }

  // console.log("[Root/main] storeUser: ", storeUser);

  return (
    <>
      <div id="main">
        <div id="sidebar">
          <Sidebar />
        </div>
        <div id="pages">
          <div id="header">
            <Header />
          </div>
          <div id="content">
            <Outlet context={[rootData, setRootData]} />
          </div>
        </div>
      </div>

      <Toaster />
    </>
  );
}
